import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FilterBar from "../components/FilterBar.js";
import ProjectStats from "./ProjectsStats.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faEdit, faEye } from "@fortawesome/free-solid-svg-icons";

  const token = localStorage.getItem('token');
const ListProjects = () => {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [stateFilter, setStateFilter] = useState("all");
  const [serviceTypeFilter, setServiceTypeFilter] = useState("all");
  const navigate = useNavigate();

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const res = await axios.get("/project");

      const nonDeleted = res.data.filter((p) => p.deletedAt === null);
      setProjects(nonDeleted);
    } catch (error) {
      console.error("Erreur lors du chargement des projets", error);
    }
  };

  const filterProjects = useCallback(() => {
    let filtered = [...projects];

    if (stateFilter !== "all") {
      filtered = filtered.filter((p) => p.state.toLowerCase() === stateFilter.toLowerCase()
      );
    }

    if (serviceTypeFilter !== "all") {
      filtered = filtered.filter((p) => p.serviceType === serviceTypeFilter);
    }
   
    setFilteredProjects(filtered);
  }, [projects, stateFilter, serviceTypeFilter]);

  useEffect(() => {
    filterProjects();
  }, [filterProjects]);

  const handleDelete = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce projet ?")) {
      try {
        await axios.delete(`/project/${id}`, {
          headers: {
            Authorization:
              `Bearer ${token}`,
          },
        });

        fetchProjects();
      } catch (error) {
        console.error("Erreur lors de la suppression", error);
      }
    }
  };

  return (
    <div className="dashboard-container">
      {/* Top Bar */}
      <div className="top-bar">
        <h3>Gestion des projets</h3>
        <div>
          <button onClick={() => navigate("/admin/projects/new")} className="bout-new">
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: "8px" }} />
            Nouveau projet
          </button>

          <button onClick={() => navigate("/admin/projects/trash")} className="bout-trash">
            <FontAwesomeIcon icon={faTrash} style={{ marginRight: "8px" }} />
            Corbeille
          </button>
        </div>
      </div>

      {/* Filtres */}
      <FilterBar
        stateFilter={stateFilter}
        onStateChange={setStateFilter}
        serviceTypeFilter={serviceTypeFilter}
        onServiceTypeChange={setServiceTypeFilter}
      />
      
      {/* Tableau */}
      <div className="liste p-4">
        <h3 className="listeh">Liste des projets</h3>
        <table className="w-full border mt-2">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">Nom</th>
              <th className="p-2 border">État</th>
              <th className="p-2 border">Début</th>
              <th className="p-2 border">Fin</th>
              <th className="p-2 border">Type</th>
              <th className="p-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredProjects.length > 0 ? (
              filteredProjects.map((project) => (
                <tr key={project.id} className="text-center">
                  <td className="p-2 border">{project.projectName}</td>
                  <td className="p-2 border">{project.state}</td>
                  <td className="p-2 border">{project.startDate}</td>
                  <td className="p-2 border">{project.endDate}</td>
                  <td className="p-2 border">{project.serviceType}</td>
                  <td className="p-2 border space-x-2">
                    <button
                      onClick={() => navigate(`/admin/projects/${project.id}`)}
                      className="icon-button text-blue-600"
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                    <button
                      onClick={() => navigate(`/admin/projects/${project.id}/edit`)}
                      className="icon-button text-green-600"
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                      onClick={() => handleDelete(project.id)}
                      className="icon-button text-red-600"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="text-center p-4" colSpan={6}>
                  Aucun projet trouvé.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Statistiques */}
      <ProjectStats />

      
    </div>
  );
};

export default ListProjects;
